import { useState } from "react";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { getEnvConfig } from "../../config/config";

const AsyncLookup = ({setTeam}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);

    const searchURL = getEnvConfig().PUBLIC_SEARCH_teamsAPI;

    const handleSelection = (e) => {

        if(e.length > 0){
            setTeam(e[0].id);
        } 
        else{
            setTeam("");
        }

    };

    const handleSearch = (query) => {

        setIsLoading(true);

        fetch(searchURL,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `
                    query findRoster($pageArgs:PaginationArgs, $sort: SortOrder, $filter: RosterFilterOptionsInput){
                        findRoster(pageArgs:$pageArgs, sort:$sort, filter:$filter){
                        results{
                            groupId
                            groupName
                        }
                        total
                        }
                    }
                `,
                variables: {
                    "pageArgs":{
                        "limit":20,
                        "skip": 0
                    },
                    "sort": {
                        "field":"groupName",
                        "direction":"ASC"
                    },
                    "filter":{
                        "groupName":{
                            "contains": query
                        }
                    }
                }
            })
        })
            .then(response => response.json())
            .then((data) => {

                if(!data.errors){
                    
                    const options = data.data.findRoster.results.map((i) => ({
                        id: i.groupId,
                        text: i.groupName,
                    }));

                    setOptions(options);
                    setIsLoading(false);
 
                }

            });

    };

    // Bypass client-side filtering by returning `true`. Results are already
    // filtered by the search endpoint, so no need to do it again.
    const filterBy = () => true;

    return (
        <AsyncTypeahead
            filterBy={filterBy}
            id="async-example"
            isLoading={isLoading}
            labelKey={(option) => option.text
                    .replace(/&nbsp;/g, " ")
                    .replace(/&#39;/g, "'")
                    .replace(/&amp;/g, "&")}
            minLength={3}
            onSearch={handleSearch}
            options={options}
            onChange={handleSelection}
            placeholder="Type team..."
            maxResults={20}
            renderMenuItemChildren={(option, props) => (
                <span>{
                    option.text
                    .replace(/&nbsp;/g, " ")
                    .replace(/&#39;/g, "'")
                    .replace(/&amp;/g, "&")
                }</span>
            )}
        />
    );

};

export default AsyncLookup;